export default "__VITE_ASSET__b6fcbca0__"